var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, computed, makeObservable, observable, runInAction, } from 'mobx';
import { AmenitiesService } from '@data/api/services/amenities';
import Store from '@data/stores/Store';
import { normalizeAmenitiesFromDTO } from '@business/utils/amenities';
import { persistentPropertyStorage } from '../PersistentPropertyStorage';
export default class Amenities {
    constructor() {
        Object.defineProperty(this, "amenitiesMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "isUsingNewAmenitiesSystem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this);
    }
    get storageKey() {
        return 'amenities';
    }
    get propertyAmenities() {
        var _a;
        return (_a = this.amenitiesMap['property']) !== null && _a !== void 0 ? _a : [];
    }
    // Union of property and room amenities used as the amenity filter options.
    // Custom amenities (no code) are excluded — they have no stable URL identifier.
    get amenityFilterOptions() {
        const byCode = new Map();
        Object.values(this.amenitiesMap).forEach((amenities) => {
            amenities.forEach((amenity) => {
                if (!amenity.code) {
                    return;
                }
                const existing = byCode.get(amenity.code);
                if (!existing) {
                    byCode.set(amenity.code, Object.assign({}, amenity));
                    return;
                }
                if (amenity.isTop) {
                    existing.isTop = true;
                }
            });
        });
        return [...byCode.values()];
    }
    getRoomAmenities(roomId) {
        var _a;
        return (_a = this.amenitiesMap[roomId]) !== null && _a !== void 0 ? _a : [];
    }
    get propertyId() {
        var _a;
        return ((_a = Store.property.model) === null || _a === void 0 ? void 0 : _a.id) || 0;
    }
    load() {
        var _a;
        const loadedData = persistentPropertyStorage.getItem(this.storageKey);
        if (loadedData) {
            const parsedData = JSON.parse(loadedData);
            this.amenitiesMap = (_a = parsedData.amenitiesMap) !== null && _a !== void 0 ? _a : {};
        }
    }
    loadPropertyAmenities() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.amenitiesMap['property']) {
                return this.amenitiesMap['property'];
            }
            const dtos = yield AmenitiesService.fetchPropertyAmenities(this.propertyId);
            const amenities = normalizeAmenitiesFromDTO(dtos);
            runInAction(() => {
                this.amenitiesMap['property'] = amenities;
            });
            return amenities;
        });
    }
    loadRoomAmenities(roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = roomId;
            if (this.amenitiesMap[key]) {
                return this.amenitiesMap[key];
            }
            const dtos = yield AmenitiesService.fetchRoomAmenities(this.propertyId, roomId);
            const amenities = normalizeAmenitiesFromDTO(dtos);
            runInAction(() => {
                this.amenitiesMap[key] = amenities;
            });
            return amenities;
        });
    }
    loadRoomAmenitiesForRooms(roomIds) {
        roomIds.forEach((id) => this.loadRoomAmenities(id).catch(() => {
            // Silently swallow — the room simply won't match amenity filters
        }));
    }
    save() {
        persistentPropertyStorage.setItem(this.storageKey, JSON.stringify({
            amenitiesMap: this.amenitiesMap,
        }));
    }
    setIsUsingNewAmenitiesSystem(isUsing) {
        this.isUsingNewAmenitiesSystem = isUsing;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Amenities.prototype, "amenitiesMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Amenities.prototype, "isUsingNewAmenitiesSystem", void 0);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Amenities.prototype, "propertyAmenities", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Amenities.prototype, "amenityFilterOptions", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], Amenities.prototype, "propertyId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Amenities.prototype, "load", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Amenities.prototype, "setIsUsingNewAmenitiesSystem", null);
